import React from 'react';
import { connect } from "react-redux";
import * as Tools from "../../helpers/Tools";
import * as types from "../../constants/actionTypes";
import PharmacyNotFound from "./PharmacyNotFound";
import { logUI } from "../../api/andyliticsApi";
import Spinner from "../common/spinner";
import { Link, Redirect } from "react-router-dom";
import StatusBanner from '../common/StatusBanner';
import MyChartNotFound from './MyChartNotFound';
import GrantPharmacyAdultProxyTerms from './termsModalContent/grant/GrantPharmacyAdultProxyTerms';
import GrantMedicalRecordsAdultProxyTerms from './termsModalContent/grant/GrantMedicalRecordsAdultProxyTerms';
import DatePickerWithMaskedInput from "../common/DatePickerWithMaskedInput";
import Terms from './Terms';
import { PROXY_APPROVED, PROXY_PENDING, PROXY_CANCELLED, EPIC, RX, RXEPIC, EPICRX, REQUEST, REQUESTV2, GRANT, ACCEPT, RXREQUEST, EPICREQUEST, RX_GRANT_ACCEPT_ADULT_FEATUREID, RX_REQUEST_ACCEPT_ADULT_FEATUREID } from "../../constants/textConstants";
import * as ProxyHelper from "./ProxyHelper"; 

//MAGIC STRINGS
const NOTAUTHORIZED = "NOTAUTHORIZED";
const UNABLETOPROCESS = "Sorry, we're unable to continue.";
const DEFAULTGRANTERROR = "We were unable to grant access to this person's records.";
const DEFAULTGRANTPHARMACYERROR = "We were unable to grant access to this person's pharmacy.";
const DEFAULTGRANTMEDICALERROR = "We were unable to grant access to this person's medical records.";
const GRANTERROR = "The date of birth could not be confirmed. If this was an error, please ask the granter to resubmit the request.";
const PROCESSCONFLICT = "This request has already been processed.";

//Magic Error Objects
const NOTAUTHORIZEDBANNER = { bannerMessage: UNABLETOPROCESS, subBannerMessage: "You are not authorized to process this request." };

class AcceptProxy extends React.Component {
    constructor(props) {
        super(props);
        const { proxyrequestid, proxyname, proxysource } = this.props.match.params;
        const { location, enableProxyRequestV2, enableProxyRXRequestAttestation} = this.props;
        const pathname = location && location.pathname && location.pathname.includes("/rx/acceptproxy");
        const isProxyRequestPath = location && location.pathname && location.pathname.includes("/proxyrequest/");
        const grantPath = location && location.pathname && location.pathname.includes("/proxygrant/accept");
        const proxySource = enableProxyRequestV2 && proxysource ? proxysource : pathname ? RX : grantPath ? proxysource : "";
        const requestType = enableProxyRXRequestAttestation && proxysource.toLowerCase() === RX && !grantPath ? REQUEST : enableProxyRequestV2 && isProxyRequestPath ? REQUESTV2 : pathname ? REQUEST : grantPath ? GRANT : "";
        const requestAction = pathname || grantPath ? ACCEPT : "";
        this.state = {
            action: requestAction,
            requestType: requestType,
            proxySource: proxySource ? proxySource.toLowerCase() === 'both' ? RXEPIC : proxySource.toLowerCase() : "",
            proxyRequestId: proxyrequestid,
            isErrorOnRequest: false,
            isGrantSubmit: false,
            dateOfBirth: "",
            validDob: true,
            validationError: "",
            name: proxyname ? this.getNameFromParams(proxyname, requestType) : "",
            showTerms: false,
            isGrantProxyMappingDone: false,
            grantMappingError: '',
            defaultSubErrorMessage: 'Please try again later.',
            attemptsRemaining: 3,
            verifyRequestorDOBActionError: null,
            linkText: ""     
        };
        this.onRxLinked = this.onRxLinked.bind(this);
        this.gotItCallback = this.gotItCallback.bind(this);
        this.callbackOnApprove = this.callbackOnApprove.bind(this);
        this.updateProxy = this.updateProxy.bind(this);
        this.approveRequest = this.approveRequest.bind(this);
        this.approveV2OnRxLinkedRequest = this.approveV2OnRxLinkedRequest.bind(this);
        this.isProxyRequestIdExist = this.isProxyRequestIdExist.bind(this);
        this.validateAnonymousRequest = this.validateAnonymousRequest.bind(this);
        this.approveAnonymousRequest = this.approveAnonymousRequest.bind(this);
        this.updateProxyRequestStatus = this.updateProxyRequestStatus.bind(this);
        this.grantAgreeAndSubmit = this.grantAgreeAndSubmit.bind(this);
        this.callbackOnGrantProxyMapping = this.callbackOnGrantProxyMapping.bind(this);
        this.callbackForGrantGetProxy = this.callbackForGrantGetProxy.bind(this);
        this.callbackOnAgreeAndSubmitGrant = this.callbackOnAgreeAndSubmitGrant.bind(this);
        this.callbackOnUnder18 = this.callbackOnUnder18.bind(this); //If  age<18 then cancel the request.
        this.callbackOnVerifyDOB = this.callbackOnVerifyDOB.bind(this);
        this.dobInputId = "dobInput";
    }

    componentDidMount() {
        this.mounted = true;
        const { proxyRequestId, proxySource, requestType } = this.state;
        const { changeRequestStatusAction, clearRequestProxyChangeStatusError} = this.props;
        logUI(`MBHWeb.UI.AcceptProxy.${ProxyHelper.getLogRequestType(requestType)}.ComponentDidMount`, new Date(), Tools.getURLPath());

        // Clearing error object on initial load.
        changeRequestStatusAction && changeRequestStatusAction.error && clearRequestProxyChangeStatusError();
        if (requestType === GRANT && this.props.age && this.props.age < 18) {                       
            this.updateProxyRequestStatus(PROXY_PENDING, "", "", this.callbackOnUnder18); //If  age<18 then make it pending first and in callback cancel the request
            logUI(`MBHWeb.${ProxyHelper.getLogProxySource(proxySource)}.AcceptProxy.${ProxyHelper.getLogRequestType(requestType)}.MinorGrant.Pending`, new Date(), Tools.getURLPath(), JSON.stringify({ ProxyRequestId: proxyRequestId }));
        } else {
            this.doGetProxyInfo(this.updateProxy);
        }
    }

    //If  age<18 then cancel the request.
    callbackOnUnder18(status, rsp) {
        const { proxyRequestId, proxySource, requestType } = this.state;
        if (status && status === 'success') {
            this.updateProxyRequestStatus(PROXY_CANCELLED, "", "This recipient is under 18 years old.", null); //If  age<18 then cancel the request.
            logUI(`MBHWeb.${ProxyHelper.getLogProxySource(proxySource)}.AcceptProxy.${ProxyHelper.getLogRequestType(requestType)}.Cancelled`, new Date(), Tools.getURLPath(), JSON.stringify({ ProxyRequestId: proxyRequestId }));
        }
    }

    getNameFromParams(name, requestType) {
        try {
            if (name) {
                return window.atob(name);
            }
        } catch (e) {
            logUI(`MBHWeb.UI.AcceptProxy.${ProxyHelper.getLogRequestType(requestType)}.NameParsingError`, new Date(), Tools.getURLPath());
            return "";
        }
        return "";
    }

    updateProxy(status, rsp) {        
        const { proxyRequestId, proxySource, requestType } = this.state;
        const { hasPharmacyLogin, proxyRequesteeInfo, hasMychartLogin, enableProxyRequestV2, enableProxyRXRequestAttestation } = this.props;
        //if ProxyInfo API Failure then let API validate by proxyid 
        const isProxyIdPresent = (status === 'success' && rsp) ? this.isProxyRequestIdExist(rsp) : true;
        if ((proxySource.toLowerCase() === RX || proxySource.toLowerCase() === EPIC) && (requestType.toLowerCase() === REQUEST || (enableProxyRequestV2 && requestType.toLowerCase() === REQUESTV2))) {
            if (((proxySource.toLowerCase() === RX && hasPharmacyLogin) || (proxySource.toLowerCase() === EPIC && hasMychartLogin && enableProxyRequestV2)) && isProxyIdPresent) {
                this.approveRequest(false, rsp);
            }
            else if ((!isProxyIdPresent && !proxyRequesteeInfo) || (!isProxyIdPresent && proxyRequesteeInfo && ((proxySource.toLowerCase() === RX && hasPharmacyLogin) || (proxySource.toLowerCase() === EPIC && hasMychartLogin && enableProxyRequestV2)))) {
                logUI(`MBHWeb.${ProxyHelper.getLogProxySource(proxySource)}.AcceptProxy.${ProxyHelper.getLogRequestType(requestType)}.UnAuthorizedRequest`, new Date(), Tools.getURLPath(), JSON.stringify({ ProxyRequestId: proxyRequestId }));
                this.showUnAuthorizedMessage();
            }
            else if (enableProxyRXRequestAttestation  && proxySource.toLowerCase() === RX && !hasPharmacyLogin && isProxyIdPresent && requestType.toLowerCase() === REQUEST) {
                this.approveV2OnRxLinkedRequest();
            }
            else if ((isProxyIdPresent && ((!hasPharmacyLogin && proxySource.toLowerCase() === RX) || (enableProxyRequestV2 && !hasMychartLogin && proxySource.toLowerCase() === EPIC))) || ((!isProxyIdPresent || status === 'failure') && proxyRequesteeInfo && (proxyRequesteeInfo === RXREQUEST || (proxyRequesteeInfo === EPICREQUEST && enableProxyRequestV2)))) {
                this.setState({ isErrorOnRequest: false });
            }
            else
                this.setState({ isErrorOnRequest: true });
        } else {
            //Grant Workflow: check proxy is already present, if not then changes status to pending.
            if (this.props.age && this.props.age > 17) {
                if (!isProxyIdPresent) {
                    this.updateProxyRequestStatus(PROXY_PENDING, "", "", this.callbackOnGrantProxyMapping);
                } else {
                    const currentProxyInfo = (status === 'success' && rsp) ? this.GetProxyInfoById(rsp) : null;
                    this.setState({
                        name: currentProxyInfo && currentProxyInfo.FirstName ? currentProxyInfo.FirstName : "",
                        isGrantProxyMappingDone: true
                    });
                }
            }
        }
    }

    approveRequest(onRxLinked = false, proxyInfoRsp = null) {
        const { hasPharmacyLogin, enableProxyRequestV2, hasMychartLogin } = this.props;
        const isProxyIdPresent = this.isProxyRequestIdExist(proxyInfoRsp);
        const { proxyRequestId, proxySource, requestType } = this.state;
        if (isProxyIdPresent && ((proxySource.toLowerCase() === RX && hasPharmacyLogin) || (proxySource.toLowerCase() === EPIC && enableProxyRequestV2 && hasMychartLogin))) {  //User has pharmacy or mychart linked and ProxyRequestId is present in ProxyInfo
            this.setState({ isErrorOnRequest: false });
            logUI(`MBHWeb.${ProxyHelper.getLogProxySource(proxySource)}.AcceptProxy.${ProxyHelper.getLogRequestType(requestType)}.Approve`, new Date(), Tools.getURLPath(), JSON.stringify({ ProxyRequestId: proxyRequestId, onRxLinked: onRxLinked }));
            this.updateProxyRequestStatus(PROXY_APPROVED, "", "", this.callbackOnApprove);
            if (!onRxLinked) {
                //this.setTimeoutEmailProxyMessage();
                //this.props.history.push("/proxymanagement");
            }
        }
        else {
            logUI(`MBHWeb.${ProxyHelper.getLogProxySource(proxySource)}.AcceptProxy.${ProxyHelper.getLogRequestType(requestType)}.UnAuthorizedRequest`, new Date(), Tools.getURLPath(), JSON.stringify({ ProxyRequestId: proxyRequestId }));
            this.showUnAuthorizedMessage();
        }
    }

    approveV2OnRxLinkedRequest() {
        const { proxyRequestId, proxySource, requestType } = this.state;
        //if (proxySource.toLowerCase() === RX && !hasPharmacyLogin  && requestType === REQUEST) {
            //this.setState({ isErrorOnRequest: false });
            //logUI(`MBHWeb.${ProxyHelper.getLogProxySource(proxySource)}.AcceptProxy.${ProxyHelper.getLogRequestType(requestType)}.Approve`, new Date(), Tools.getURLPath(), JSON.stringify({ ProxyRequestId: proxyRequestId }));
            //this.updateProxyRequestStatus(PROXY_APPROVED, "", "", this.callbackOnApprove);
            //this.props.history.push("/proxymanagement");
        //}
        this.props.history.push(`/acceptRxProxyTerms/accept/${proxyRequestId}/${proxySource}/${requestType}/`);
    }

    showUnAuthorizedMessage() {
        let errorMessage = this.getErrorMessage("failure", NOTAUTHORIZED);
        this.setState({
            grantMappingError: errorMessage,
            linkText: "Manage family accounts"
        });
    }

    doGetProxyInfo(callback = null) {
        const { userId, getRequestProxyInfo } = this.props;
        if (userId)
            getRequestProxyInfo("", userId, callback); //request + grant list, No need to send proxysource as we need complete list for Rx and epic   
    }

    /* PharmacyNotFound - Got It callback*/
    gotItCallback(event) {
        this.setInPharmacyNotFound(false);
        this.setTimeoutEmailProxyMessage();
        this.props.history.push("/proxymanagement");
    }

    /* PharmacyNotFound - On Verify and Link callback*/
    onRxLinked(dateOfBirth) {  // this dateOfBirth is the one which is entered on PharmacyNotFound screen.
        if (!dateOfBirth) return;
        const { proxyRequestId, proxySource, requestType } = this.state;
        const { proxyRequesteeInfo, enableProxyRequestV2 } = this.props;
        if (proxySource === RX && (requestType === REQUEST || (enableProxyRequestV2 && requestType.toLowerCase() === REQUESTV2))) {
            if (proxyRequesteeInfo && (proxyRequesteeInfo === RXREQUEST || (proxyRequesteeInfo === EPICREQUEST && enableProxyRequestV2))) {
                logUI(`MBHWeb.${ProxyHelper.getLogProxySource(proxySource)}.AcceptProxy.${ProxyHelper.getLogRequestType(requestType)}.AnonymousUser.InitiateLink`, new Date(), Tools.getURLPath(), JSON.stringify({ ProxyRequestId: proxyRequestId }));
                //Initiated anyonymousrequest with linkage.
                this.updateProxyRequestStatus(PROXY_PENDING, dateOfBirth, "", this.validateAnonymousRequest);
                this.props.updateProxyRequesteeInfo(); // Resetting the Preference here.
            }
            else {
                this.approveRequest(true);
            }
        }
    }

    //Validate anyonymous request linkage.
    validateAnonymousRequest(status, rsp) {
        const { proxyRequestId, proxySource, requestType } = this.state;
        const { updateUIStatus } = this.props;
        if (status && status === 'success') {
            logUI(`MBHWeb.${ProxyHelper.getLogProxySource(proxySource)}.AcceptProxy.${ProxyHelper.getLogRequestType(requestType)}.AnonymousUser.InitiateLink.Success`, new Date(), Tools.getURLPath(), JSON.stringify({ ProxyRequestId: proxyRequestId }));
            //this.doGetProxyInfo(this.approveAnonymousRequest); //commented as per UX change we do not auto approve for anonymous user request.
        } else {
            logUI(`MBHWeb.${ProxyHelper.getLogProxySource(proxySource)}.AcceptProxy.${ProxyHelper.getLogRequestType(requestType)}.AnonymousUser.InitiateLink.Failure`, new Date(), Tools.getURLPath(), JSON.stringify({ ProxyRequestId: proxyRequestId }));
            const errorMessage = this.getErrorMessage(status, rsp, true);
            updateUIStatus(PROXY_APPROVED, proxyRequestId, status, errorMessage);
        }
    }

    // Set timeout for displaying message
    setTimeoutEmailProxyMessage() {
        window.setTimeout(() => {
            this.props.clearEmailProxyMessage();
        }, 10000);
    }

    // Hold proxyRequestId  for  displaying status message
    callbackOnApprove(status, rsp) {
        const { proxyRequestId, proxySource, requestType } = this.state;
        const { updateUIStatus } = this.props;
        let errorMessage = null;
        let activityCode = `MBHWeb.${ProxyHelper.getLogProxySource(proxySource)}.AcceptProxy.${ProxyHelper.getLogRequestType(requestType)}.Approve.Failure`;
        if (status) {
            if (status === 'success') {
                activityCode = `MBHWeb.${ProxyHelper.getLogProxySource(proxySource)}.AcceptProxy.${ProxyHelper.getLogRequestType(requestType)}.Approve.Success`;
                this.setTimeoutEmailProxyMessage();
                this.props.history.push("/proxymanagement");
            }
            else {
                errorMessage = UNABLETOPROCESS;
                let defaultSubErrorMessage = this.state.defaultSubErrorMessage;
                defaultSubErrorMessage = this.getErrorMessage(status, rsp);
                this.setState({
                    grantMappingError: errorMessage,
                    defaultSubErrorMessage
                });
            }
            //updateUIStatus(PROXY_APPROVED, proxyRequestId, status, errorMessage);
        }
        logUI(activityCode, new Date(), Tools.getURLPath(), JSON.stringify({ ProxyRequestId: proxyRequestId }));
    }

    //Approve Anyonymous Request
    approveAnonymousRequest(status, rsp) {
        const { proxyRequestId, proxySource,requestType } = this.state;
        if (status && status === 'success') {
            logUI(`MBHWeb.${ProxyHelper.getLogProxySource(proxySource)}.AcceptProxy.${ProxyHelper.getLogRequestType(requestType)}.Approve.AnonymousUser.Success`, new Date(), Tools.getURLPath(), JSON.stringify({ ProxyRequestId: proxyRequestId }));
            this.approveRequest(true, rsp);
        } else {
            logUI(`MBHWeb.${ProxyHelper.getLogProxySource(proxySource)}.AcceptProxy.${ProxyHelper.getLogRequestType(requestType)}.Approve.AnonymousUser.Failure`, new Date(), Tools.getURLPath(), JSON.stringify({ ProxyRequestId: proxyRequestId }));
            this.showUnAuthorizedMessage();
        }
    }

    //check if ProxyRequestId exist in proxy info.
    isProxyRequestIdExist(response = null) {
        const { proxyRequestId, proxySource, requestType } = this.state;
        const { requestProxyInfo, enableProxyRequestV2 } = this.props;
        let isProxyIdExist = false;
        const responseInfo = response ? response : (requestProxyInfo && requestProxyInfo.response) ? requestProxyInfo.response : null;
        logUI(`MBHWeb.${ProxyHelper.getLogProxySource(proxySource)}.AcceptProxy.${ProxyHelper.getLogRequestType(requestType)}.isProxyRequestIdExist`, new Date(), Tools.getURLPath(), JSON.stringify({ ProxyRequestId: proxyRequestId }));
        if (responseInfo) {
            if (requestType.toLowerCase() === REQUEST || (enableProxyRequestV2 && requestType.toLowerCase() === REQUESTV2)) {
                isProxyIdExist = responseInfo.WhoCanManageYou && responseInfo.WhoCanManageYou.filter(account => account.RequestType.toLowerCase() === REQUEST || (enableProxyRequestV2 && requestType.toLowerCase() === REQUESTV2) && account.ProxyRequestId === proxyRequestId).length > 0 ? true : false;
            } else {
                isProxyIdExist = responseInfo.WhoYouCanManage && responseInfo.WhoYouCanManage.filter(account => account.RequestType.toLowerCase() === GRANT && account.ProxyRequestId === proxyRequestId).length > 0 ? true : false;
            }
        }
        return isProxyIdExist;
    }

    //Update Proxy Request Status with Approved, Pending etc..
    updateProxyRequestStatus(proxyStatus, dateOfBirth = "", reason = "", callback) {
        const { proxyRequestId, proxySource, requestType } = this.state;  
        this.props.changeRequestStatus(proxyRequestId, proxySource, requestType, proxyStatus, reason, dateOfBirth, callback);
    }

    // Get Error Message from changeRequestStatus response.
    getErrorMessage(status, rsp, isAnonymous = false) {
        let errorMessage = null;
        const { proxyRequestId, proxySource, requestType } = this.state; 
        if (status === 'failure') {
            logUI(`MBHWeb.${ProxyHelper.getLogProxySource(proxySource)}.AcceptProxy.${ProxyHelper.getLogRequestType(requestType)}.GetErrorMessage`, new Date(), Tools.getURLPath(), JSON.stringify({ response: rsp }));
            if (rsp && typeof rsp === "string") {
                switch (rsp) {
                    case "Internal Server Error":
                        errorMessage = UNABLETOPROCESS;
                        break;
                    case "Conflict":
                        errorMessage = PROCESSCONFLICT;
                        break;
                    case "The request has already been processed.":
                        errorMessage = PROCESSCONFLICT;
                        break;
                    case NOTAUTHORIZED:
                        errorMessage = NOTAUTHORIZED;
                        break;
                    default:
                        errorMessage = UNABLETOPROCESS;
                        break;
                }
            }
            else if (rsp && rsp.message) {
                errorMessage = NOTAUTHORIZED;
            }
            else if (rsp && typeof (rsp) === "object") {
                if (rsp.errorCode &&
                    (rsp.errorCode.toLowerCase() === "receiverandrequestersame" ||
                        rsp.errorCode.toLowerCase() === "receiveralreadyhasaccess" ||
                        rsp.errorCode.toLowerCase() === "granteralreadyhasaccess" ||
                        rsp.errorCode.toLowerCase() === "invaliddob" ||
                        rsp.errorCode.toLowerCase() === "accountaccessexists")) {
                        errorMessage = rsp.errorMessage;
                    } else {
                        errorMessage = UNABLETOPROCESS;
                    }
            }
            else {
                errorMessage = rsp;
            }
        }
        return errorMessage;
    }

    getGrantErrorMessage(error, proxySource) {
        const defaultErrorMessage = proxySource === EPIC ? DEFAULTGRANTMEDICALERROR : proxySource === RX ? DEFAULTGRANTPHARMACYERROR : DEFAULTGRANTERROR;
        let errorMessage = null;
        if (error && typeof error === "string") {
            switch (error) {
                case "Bad Request"://right now handling it for specific, but may be removed later.
                    errorMessage = defaultErrorMessage;
                    break;
                case "Conflict":
                    errorMessage = UNABLETOPROCESS; //"This request has already been processed.";
                    break;
                default:
                    errorMessage = defaultErrorMessage;
                    break;
            }
        }
        else if ((error && typeof error === "object") || (error && error.errorMessage)) {
            if (error.errorMessage) {
                errorMessage = error.errorMessage;
            }
            else {
                errorMessage = error.message && error.message !== "" ? error.message : defaultErrorMessage;
            }            
        }
        else {
            errorMessage = defaultErrorMessage;
        }
      
        return errorMessage;
    }

    setInPharmacyNotFound = (value) => {
        this.setState({ inPharmacyNotFound: value });
    }

    handleValidationAndOnContinueClick(event) {
        if (this.mounted) {
            if (this.isValidate()) {
                const { proxyRequestId, dateOfBirth } = this.state;  
                this.props.verifyRequestorDateOfBirth(proxyRequestId, dateOfBirth, this.callbackOnVerifyDOB);
            }
            else {
                event.preventDefault();
            }
        }
    }

    getProxyTermsAndConditions() {
        const { age, getProxyTermsAndConditionsAction, useTermsV2Endpoint } = this.props;
        const { proxySource, requestType, action } = this.state;
        const isMinor = age != null && age < 18;

        // Get featureId
        const featureId = !isMinor && action === ACCEPT ? ProxyHelper.getFeatureId(requestType, proxySource, age, action) : null;

        // Check if already called getProxyTermsAndConditions
        const fetchedProxyTermsAndConditions = useTermsV2Endpoint ? featureId !== null && getProxyTermsAndConditionsAction && getProxyTermsAndConditionsAction.response && getProxyTermsAndConditionsAction.response[0].featureId && getProxyTermsAndConditionsAction.response[0].featureId === featureId : featureId !== null && getProxyTermsAndConditionsAction && getProxyTermsAndConditionsAction.response && getProxyTermsAndConditionsAction.response.featureId && getProxyTermsAndConditionsAction.response.featureId === featureId;

        // if not called getProxyTermsAndConditions, call getProxyTermsAndConditions
        if (!fetchedProxyTermsAndConditions && featureId !== null && featureId !== RX_GRANT_ACCEPT_ADULT_FEATUREID && featureId !== RX_REQUEST_ACCEPT_ADULT_FEATUREID) {
            logUI(`MBHWeb.${ProxyHelper.getLogProxySource(proxySource)}.AcceptProxy.${ProxyHelper.getLogRequestType(requestType)}.GetProxyTermsAndConditions.onGrantAccess`, new Date(), Tools.getURLPath());
            this.props.getProxyTermsAndConditions(featureId);
        }     
    }

    acceptProxyTermsAndConditions() {
        const { userName, myChartId, age, getProxyTermsAndConditionsAction, useTermsV2Endpoint } = this.props;
        const { proxySource, requestType, action } = this.state;
        const featureId = ProxyHelper.getFeatureId(requestType, proxySource, age, action);
        const versionId = useTermsV2Endpoint ? getProxyTermsAndConditionsAction.response[0].versionId : getProxyTermsAndConditionsAction.response.versionId;
        logUI(`MBHWeb.${ProxyHelper.getLogProxySource(proxySource)}.AcceptProxy.${ProxyHelper.getLogRequestType(requestType)}.AcceptTermsAndConditions`, new Date(), Tools.getURLPath());
        this.props.acceptProxyTermsAndConditions(featureId, true, userName, "", myChartId, "", versionId); // Save proxy terms and conditions flag  
    }

    callbackOnVerifyDOB(status, rsp) {
        const { proxyRequestId, proxySource, requestType } = this.state;
        let activityCode = `MBHWeb.${ProxyHelper.getLogProxySource(proxySource)}.AcceptProxy.${ProxyHelper.getLogRequestType(requestType)}.VerifyDOB.Failure`;
        if (status) {
            if (status === 'success') {
                activityCode = `MBHWeb.${ProxyHelper.getLogProxySource(proxySource)}.AcceptProxy.${ProxyHelper.getLogRequestType(requestType)}.VerifyDOB.Success`;
                this.getProxyTermsAndConditions();
                this.setState({ validationError: "", showTerms: true });
            }
            if (status === 'failure') {
                if (rsp.errorCode === "InvalidDOB") {
                    this.setState({ attemptsRemaining: rsp.attemptsRemaining, verifyRequestorDOBActionError: rsp });
                }
                else {
                    this.setState({ verifyRequestorDOBActionError: rsp });
                }
                activityCode = `MBHWeb.${ProxyHelper.getLogProxySource(proxySource)}.AcceptProxy.${ProxyHelper.getLogRequestType(requestType)}.VerifyDOB.Failure`;
            }
        }
        logUI(activityCode, new Date(), Tools.getURLPath(), JSON.stringify({ ProxyRequestId: proxyRequestId }));
    }

    getVerifyDOBErrorMessage(is400Error=false, proxySource) {
        const { verifyRequestorDOBActionError } = this.state;
        let errorKey = verifyRequestorDOBActionError && typeof verifyRequestorDOBActionError !== "undefined" && verifyRequestorDOBActionError.statusText ? verifyRequestorDOBActionError.statusText : "";
        if (is400Error) {
            errorKey = verifyRequestorDOBActionError && typeof verifyRequestorDOBActionError !== "undefined" && verifyRequestorDOBActionError.errorCode && verifyRequestorDOBActionError.errorCode === 'InvalidDOB' ? verifyRequestorDOBActionError : "";
        }
        const verifyDOBError = errorKey ? this.getGrantErrorMessage(errorKey, proxySource) : "";
        return verifyDOBError;
    }

    isValidate() {
        if (this.mounted) {
            const { dateOfBirth } = this.state;
            const validDob = this.digits(dateOfBirth, 6);
            if (validDob !== this.state.validDob) {
                this.setState({ validDob });
            }
            // call API to check this validDob

            //if (!validDob) this.inputId = dobInputId;
            return validDob;
        }
    }

    digits(str, length) {
        return str && str.replace(/[^0-9]/g, '').length >= length;
    }

    GetProxyInfoById(response = null) {
        const { proxyRequestId, requestType } = this.state;
        const { requestProxyInfo, enableProxyRequestV2 } = this.props;
        let proxyInfo = null;
        const responseInfo = response ? response : (requestProxyInfo && requestProxyInfo.response) ? requestProxyInfo.response : null;
        if (responseInfo) {
            let proxyList = [];
            if (requestType && (requestType.toLowerCase() === REQUEST || (enableProxyRequestV2 && requestType.toLowerCase() === REQUESTV2)) && responseInfo.WhoCanManageYou) {
                proxyList = responseInfo.WhoCanManageYou;
            } else if (responseInfo.WhoYouCanManage) {
                proxyList = responseInfo.WhoYouCanManage;
            }
            for (let pl = 0; pl < proxyList.length; pl++) {
                const account = proxyList[pl];
                if (account.RequestType.toLowerCase() === requestType.toLowerCase() && account.ProxyRequestId === proxyRequestId) {
                    proxyInfo = account;
                    break;
                }
            }
        }
        return proxyInfo;
    }

    callbackForGrantGetProxy(status, rsp) {
        const { proxyRequestId, proxySource, requestType } = this.state;
        let activityCode = `MBHWeb.${ProxyHelper.getLogProxySource(proxySource)}.AcceptProxy.${ProxyHelper.getLogRequestType(requestType)}.GetGrantProxy.Failure`;
        this.setState({ isGrantProxyMappingDone: true });
        if (status) {
            if (status === 'success') {
                activityCode = `MBHWeb.${ProxyHelper.getLogProxySource(proxySource)}.AcceptProxy.${ProxyHelper.getLogRequestType(requestType)}.GetGrantProxy.Success`;
                const currentProxyInfo = rsp ? this.GetProxyInfoById(rsp) : null;
                if (currentProxyInfo && currentProxyInfo.FirstName) {
                    this.setState({
                        name: currentProxyInfo.FirstName
                    });
                }
            }
        }
        logUI(activityCode, new Date(), Tools.getURLPath(), JSON.stringify({ ProxyRequestId: proxyRequestId }));
    }

    callbackOnGrantProxyMapping(status, rsp) {
        if (status) {
            if (status === 'success') {
                setTimeout(() => {
                    this.doGetProxyInfo(this.callbackForGrantGetProxy);
                }, 1000)
            } else {
                let errorMessage = this.getErrorMessage(status, rsp);
                let alreadyHasAccess = rsp && rsp.errorCode && (rsp.errorCode.toLowerCase() === "receiveralreadyhasaccess" || rsp.errorCode.toLowerCase() === "accountaccessexists");
                let defaultSubErrorMessage = this.state.defaultSubErrorMessage;
                if ((rsp && typeof (rsp) === "string" && rsp.toLowerCase() === "conflict") || alreadyHasAccess) {
                    defaultSubErrorMessage = errorMessage;
                    errorMessage = UNABLETOPROCESS;
                }
                this.setState({
                    grantMappingError: errorMessage,
                    defaultSubErrorMessage,
                    linkText: alreadyHasAccess ? "Manage family accounts" : ""
                });
            }
        }
    }

    grantAgreeAndSubmit() {
        this.setState({ showTerms: false, isGrantSubmit: true });
        const { proxySource,requestType } = this.state;
        this.acceptProxyTermsAndConditions();
        logUI(`MBHWeb.${ProxyHelper.getLogProxySource(proxySource)}.AcceptProxy.${ProxyHelper.getLogRequestType(requestType)}.SubmitProxyGrantAccess`, new Date(), Tools.getURLPath());        
        this.updateProxyRequestStatus(PROXY_APPROVED, this.state.dateOfBirth, "", this.callbackOnAgreeAndSubmitGrant);
    }

    // Hold proxyRequestId  for  displaying status message For Grant
    callbackOnAgreeAndSubmitGrant(status, rsp) {
        const { proxyRequestId, requestType, proxySource } = this.state;
        let activityCode = `MBHWeb.${ProxyHelper.getLogProxySource(proxySource)}.AcceptProxy.${ProxyHelper.getLogRequestType(requestType)}.Approve.Failure`;
        if (status) {
            if (status === 'success') {
                this.props.loadProxies();
                activityCode = `MBHWeb.${ProxyHelper.getLogProxySource(proxySource)}.AcceptProxy.${ProxyHelper.getLogRequestType(requestType)}.Approve.Success`;
                let errorMessage = this.getErrorMessage(status, rsp);
                this.props.updateUIStatus(PROXY_APPROVED, proxyRequestId, status, errorMessage);
                this.setTimeoutEmailProxyMessage();
                this.props.history.push("/proxymanagement");
            } else {
                if (rsp && typeof (rsp) === "string" && rsp.toLowerCase() === "conflict") {
                    let errorMessage = this.getErrorMessage(status, rsp);
                    let defaultSubErrorMessage = this.state.defaultSubErrorMessage;
                    defaultSubErrorMessage = errorMessage;
                    errorMessage = UNABLETOPROCESS;
                    this.setState({
                        grantMappingError: errorMessage,
                        defaultSubErrorMessage
                    });
                }
            }
        }
        logUI(activityCode, new Date(), Tools.getURLPath(), JSON.stringify({ ProxyRequestId: proxyRequestId }));
    }

    onRetry = () => {
        this.props.history.push("/proxymanagement");
    }

    tryAgain() {
        const { proxyRequestId, requestType, proxySource } = this.state;
        this.props.history.push(`/proxymgmt?type=${requestType}&source=${proxySource}&action=accept&proxyRequestId=${proxyRequestId}`);
    }

    navToProxyDashboard = () => {
        this.props.history.push("/proxymanagement");
    }

    onInputChange(field, value, isValid) {
        if (value) {
            if (typeof isValid === 'undefined' || isValid) {
                this.setState({ [field]: value }, () => {
                    this.isValidate();
                });
            }
            else {
                this.isValidate();
            }
        } else {
            this.setState({ [field]: value });
        }
    }

    render() {
        const { validationError, name, proxySource, inPharmacyNotFound, requestType, proxyRequestId, isErrorOnRequest, isGrantSubmit, showTerms, isGrantProxyMappingDone, grantMappingError, attemptsRemaining, defaultSubErrorMessage, linkText } = this.state;
        const { hasPharmacyLogin, hasMychartLogin, changeRequestStatusAction, requestProxyInfo, myChartRegistrationUrl, history, proxyRequesteeInfo, proxyListLoaded, technicalHelpDeskNumber, technicalHelpDeskHours, verifyRequestorDOBAction, getProxyTermsAndConditionsAction,
                enableProxyRequestV2, enableProxyRXRequestAttestation, useTermsV2Endpoint } = this.props;
        const isBoth = (proxySource === RXEPIC || proxySource === EPICRX) ? true : false;
        const heading = isBoth ? "records" : proxySource === EPIC ? "medical records" : "BSW pharmacy";

        //Show the PharmacyNotFound component if pharmacy not linked.
        const showPharmacyNotFound = proxySource === RX && proxyRequestId && (!hasPharmacyLogin || inPharmacyNotFound) && !isErrorOnRequest && (requestType === REQUEST || (enableProxyRequestV2 && requestType.toLowerCase() === REQUESTV2));

        const hidePharmacyNotFound = proxyRequestId && (proxySource === RX && requestType === REQUEST && enableProxyRXRequestAttestation);

        //Show the Spinner.
        const isWaitingForRequest = ((requestProxyInfo && requestProxyInfo.waiting) || (verifyRequestorDOBAction && verifyRequestorDOBAction.waiting) || (changeRequestStatusAction && changeRequestStatusAction.waiting)) && (requestType === REQUEST || (enableProxyRequestV2 && requestType.toLowerCase() === REQUESTV2));

        //Get Error message when it is 400 error
        const verifyDOB400ErrorMessage = this.getVerifyDOBErrorMessage(true, proxySource);
        const errorMessage = verifyDOB400ErrorMessage ? verifyDOB400ErrorMessage : validationError;

        //Get Error message when it is not 400 error
        const verifyDOBErrorMessage = this.getVerifyDOBErrorMessage(null, proxySource);

        //get changerequeststatus error
        const changeStatusErrorMessage = changeRequestStatusAction && changeRequestStatusAction.error && changeRequestStatusAction.request && changeRequestStatusAction.request.proxyRequestId === proxyRequestId ? this.getGrantErrorMessage(changeRequestStatusAction.error, proxySource) : validationError;
        const isChangeStatusError = changeRequestStatusAction && changeRequestStatusAction.request && changeRequestStatusAction.request.proxyRequestId === proxyRequestId && !changeRequestStatusAction.waiting && !changeRequestStatusAction.success && changeRequestStatusAction.request.status !== PROXY_PENDING && changeRequestStatusAction.error ? true : false;        

        //check if full page error
        const isError = isChangeStatusError || verifyDOBErrorMessage !== "" || verifyDOB400ErrorMessage === GRANTERROR;

        //Check if the user can resubmit the DOB
        const isReSubmit = attemptsRemaining > 0 && verifyDOBErrorMessage === "" && !isChangeStatusError && verifyDOB400ErrorMessage !== GRANTERROR ? true : false;   

        //Get Fullpage error
        const errorBannerMessage =  verifyDOBErrorMessage ? verifyDOBErrorMessage : changeStatusErrorMessage;

        //Get Terms and conditions
        const termsandconditions = useTermsV2Endpoint ? getProxyTermsAndConditionsAction && getProxyTermsAndConditionsAction.response && getProxyTermsAndConditionsAction.response[0].textToDisplay ? getProxyTermsAndConditionsAction.response[0].textToDisplay : "" : getProxyTermsAndConditionsAction && getProxyTermsAndConditionsAction.response && getProxyTermsAndConditionsAction.response.textToDisplay ? getProxyTermsAndConditionsAction.response.textToDisplay : "";

        //Handling NOTAUTHORIZED or NOTAUTHORIZEDFORANYNYMOUS error
        const { bannerMessage, subBannerMessage } = grantMappingError === NOTAUTHORIZED ? NOTAUTHORIZEDBANNER : { bannerMessage: grantMappingError, subBannerMessage: defaultSubErrorMessage !== UNABLETOPROCESS ? defaultSubErrorMessage : "Please try again later." };

        // Show Overlay Spinner.
        const showOverLaySpinner = (<div className="row overlay-loading-container">
            <div className="col-12 align-self-center">
                <Spinner />
            </div>
        </div>);

        const mappingErrorBanner = (<div className="container-fluid body-content">
            <div className="row">
                <div className="col-12">
                    <StatusBanner bannerMsg={bannerMessage} failedStatus>
                        <div>{subBannerMessage}</div>
                        {linkText && linkText !== "" ? <div className="status-subBanner-msg__btn"><input type="submit" className="btn text-btn" value={linkText} onClick={() => this.navToProxyDashboard()} /></div> : null}
                    </StatusBanner>
                </div>
            </div>
        </div>);

        return (requestType === REQUEST || (enableProxyRequestV2 && requestType.toLowerCase() === REQUESTV2)
            ? <React.Fragment>{((typeof isWaitingForRequest !== 'undefined' || typeof showPharmacyNotFound !== 'undefined') && isWaitingForRequest)
                ? <Spinner />
                : grantMappingError
                    ? mappingErrorBanner
                    : <React.Fragment>
                        {(showPharmacyNotFound && !hidePharmacyNotFound)
                            ? <PharmacyNotFound onLinked={(dateOfBirth) => this.onRxLinked(dateOfBirth)} gotItCallback={this.gotItCallback} setInPharmacyNotFound={this.setInPharmacyNotFound} proxyRequesteeInfo={proxyRequesteeInfo} />
                            : ((proxySource === EPIC) && enableProxyRequestV2 && !hasMychartLogin && requestType.toLowerCase() === REQUESTV2)
                                ? <MyChartNotFound createAccountLink={myChartRegistrationUrl + "activation?s=1&option=Yes"} history={history} technicalHelpDeskHours={technicalHelpDeskHours} technicalHelpDeskNumber={technicalHelpDeskNumber} />
                                : hidePharmacyNotFound && <Spinner />}
                    </React.Fragment>}
            </React.Fragment>
            : grantMappingError 
               ? mappingErrorBanner
               : (this.props.age && this.props.age > 17) ?
                ((proxySource === EPIC || isBoth) && !hasMychartLogin) ?
                        <MyChartNotFound createAccountLink={myChartRegistrationUrl + "activation?s=1&option=Yes"} history={history} technicalHelpDeskHours={technicalHelpDeskHours} technicalHelpDeskNumber={technicalHelpDeskNumber} />
                        : !isGrantSubmit && isReSubmit?
                        !showTerms ?
                            isGrantProxyMappingDone ? <>
                            <div className="container-fluid body-content accept-dob-container sm-width-step">
                                <div className="row">
                                    <div className="col-12 maxWidth-content">
                                        <div className="row">
                                            <div className="col-12">
                                                <h1 className="step-heading step-heading-md">{name} has invited you to access their {heading}.</h1>
                                                <p className="step-description">To confirm you know {name}, please enter their date of birth.</p>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-12 step-form-container">
                                                <div className="row">
                                                    <div className="col-12 proxy-dob">
                                                                <DatePickerWithMaskedInput dobId={this.dobInputId} required value={Tools.dateStringFormat(this.state.dateOfBirth, "MM/DD/YYYY")} yearsBackward={140} maxDate={new Date()}
                                                                    onChange={(day, isValid) => {
                                                                        this.onInputChange('dateOfBirth',
                                                                            day ? Tools.dateStringFormat(day) : '', isValid);
                                                                    }}
                                                                    showAsInvalid={!this.state.validDob || (this.state.validDob && errorMessage !== "")}
                                                                    placeholder="MM/DD/YYYY"
                                                                    dateIconNeeded={false}
                                                                    isMaskedDateInput
                                                                    inputErrorMsg={this.state.validDob ? errorMessage !== "" ? errorMessage : "" : ""}
                                                        />
                                                    </div>
                                                    <div className="col-12">
                                                        <div className="footer-buttons grant-accept-footer">
                                                            {<input className="btn btn-primary" type="submit" value="Continue" onClick={(e) => this.handleValidationAndOnContinueClick(e)} />}
                                                            <Link to='/proxymanagement'>Enter their date of birth later</Link>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                </div>
                                    {
                                        //Show OverLay Spinner When verify Requestor DOB Action is waiting.
                                        verifyRequestorDOBAction && verifyRequestorDOBAction.waiting && showOverLaySpinner
                                    }
                            </> : <Spinner />
                            : <>
                               <div className="container-fluid body-content">
                                        <Terms links={[{
                                            index: 0, headingText: "terms & conditions", modalComponent: <GrantMedicalRecordsAdultProxyTerms heading="Terms & Conditions" termsandconditions={termsandconditions} />
                                        }]}
                                        callback={this.grantAgreeAndSubmit} history={this.props.history}
                                    />
                                </div>
                              </> :
                        <React.Fragment>
                                {isError  &&
                                <div className="container-fluid body-content">
                                    <div className="row">
                                        <div className="col-12">
                                            {verifyDOB400ErrorMessage ?
                                                <StatusBanner bannerAlignment="left" bannerMsg={proxySource === RX ? DEFAULTGRANTPHARMACYERROR : proxySource === EPIC ? DEFAULTGRANTMEDICALERROR : DEFAULTGRANTERROR} failedStatus>
                                                    <span>{GRANTERROR}</span>
                                                </StatusBanner>:
                                                <StatusBanner bannerMsg={errorBannerMessage} failedStatus>
                                                    <span>Please <input type="submit" className="btn text-btn" value="try again" onClick={() => this.tryAgain()} /> later.</span>
                                                </StatusBanner>                                                
                                            }
                                            
                                        </div>
                                    </div>
                                </div>
                            }
                            {
                                 //Show OverLay Spinner When changeRequestStatusAction is waiting.
                                changeRequestStatusAction && changeRequestStatusAction.waiting && showOverLaySpinner
                            }
                        </React.Fragment> :
                <div className="container-fluid body-content proxy-minor-error-container">
                    <div className="row">
                        <div className="col-12">
                                <StatusBanner bannerMsg={UNABLETOPROCESS} subBannerMsg="You must be at least 18 years old to access another person's records." failedStatus />
                        </div>
                    </div>
                </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        userId: state.domain.un,
        age: state.domain.age,
        hasMychartLogin: state.domain.hm,
        hasPharmacyLogin: state.memberships.isActiveFeature_Pharmacy,
        myChartRegistrationUrl: state.session.serverData ? state.session.serverData.myChartRegistrationUrl : "",
        history: state.session.history,
        proxyListLoaded: state.memberships.proxyListLoaded,
        changeRequestStatusAction: state.common[types.REQUEST_PROXY_CHANGE_STATUS],
        verifyRequestorDOBAction: state.common[types.VERIFY_REQUESTOR_DOB],
        requestProxyInfo: state.common[types.REQUEST_PROXY_INFO],
        getProxyTermsAndConditionsAction: state.common[types.PROXY_TERMS_AND_CONDITIONS],
        acceptProxyTermsAndConditionsAction: state.common[types.ACCEPT_PROXY_TERMS_AND_CONDITIONS],
        proxyRequesteeInfo: state.session.proxyRequesteeInfo,
        technicalHelpDeskNumber: state.session.serverData ? state.session.serverData.technicalHelpDeskNumber : "",
        technicalHelpDeskHours: state.session.serverData ? state.session.serverData.technicalHelpDeskHours:"",
        userName: state.domain.un, 
        myChartId: state.domain.mc,
        enableProxyRequestV2: state.session.serverData ? state.session.serverData.enableProxyRequestV2 : false,
        enableProxyRXRequestAttestation: state.session.serverData ? state.session.serverData.enableProxyRXRequestAttestation : false,
        useTermsV2Endpoint: state.session.serverData ? state.session.serverData.useTermsV2Endpoint : false
    };
};
const mapDispatchToProps = (dispatch) => ({
    changeRequestStatus: (proxyRequestId, proxySource, requestType, status, reason, dateOfBirth, callback) =>
        dispatch({ type: types.REQUEST_PROXY_CHANGE_STATUS, data: { proxyRequestId, proxySource, requestType, status, reason, dateOfBirth }, callback }),

    verifyRequestorDateOfBirth: (proxyRequestId, dateOfBirth, callback) =>
        dispatch({ type: types.VERIFY_REQUESTOR_DOB, data: { proxyRequestId, dateOfBirth }, callback }),

    loadProxies: () => dispatch({ type: types.REFRESH_PROXY_LIST }),

    setInPharmacyNotFound: (inPharmacyNotFound) => dispatch({ type: types.SET_PHARMACY_LINKED, data: { pharmacyLinked: inPharmacyNotFound } }),

    getRequestProxyInfo: (proxySource, userId, callback) => dispatch({ type: types.REQUEST_PROXY_INFO, data: { userId, proxySource }, callback }),

    clearEmailProxyMessage: () => dispatch({ type: types.CLEAR_EMAIL_PROXY_MESSAGE }),

    updateUIStatus: (actionType, emailProxyRequestId, status, errorMessage) => dispatch({ type: types.SET_EMAIL_APPROVED_PROXY_REQUEST, data: { actionType, emailProxyRequestId, status, errorMessage } }),

    updateProxyRequesteeInfo: () => dispatch({ type: types.UPDATE_PROXY_REQUESTEE_INFO }),

    getProxyTermsAndConditions: (featureId, callback) =>
        dispatch({ type: types.PROXY_TERMS_AND_CONDITIONS, data: { featureId }, callback }),

    acceptProxyTermsAndConditions: (featureId, isAccepted, userName, email, loginId, proxyId, versionId, callback) =>
        dispatch({ type: types.ACCEPT_PROXY_TERMS_AND_CONDITIONS, data: { featureId, isAccepted, userName, email, loginId, proxyId, versionId }, callback }),

    clearRequestProxyChangeStatusError: () => dispatch({ type: types.CLEAR_REQUEST_PROXY_CHANGE_STATUS_ERROR})
});
export default connect(mapStateToProps, mapDispatchToProps)(AcceptProxy);